import ReactGA from 'react-ga4'

export const initialise = () => {
  ReactGA.initialize([
    {
      trackingId: process.env.GOOGLE_ANALYTICS_PROPERTY || '',
      gaOptions: {
        sampleRate: 100,
        siteSpeedSampleRate: 5,
        debug_mode: process.env.NODE_ENV === 'development',
      },
      gtagOptions: {
        debug_mode: process.env.NODE_ENV === 'development',
        send_page_view: true,
      },
    },
  ])
}

export function changeB2BDevice() {
  ReactGA.event({ category: 'Provider', action: 'Change Device' })
}

export function changeMANCON() {
  ReactGA.event({ category: 'Provider', action: 'Change Nominated Person' })
}



// WEBPACK FOOTER //
// ./src/helpers/analytics.js